import React from 'react'
import { Header } from '../components/header'
import { mount } from '../utils/mount'
import { RestoreScroll } from '../components/restore-scroll'

mount('#header-root', <>
  <RestoreScroll />
  <Header />
</>)